
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"#008C89"}}),_c('path',{attrs:{"fill":"#008C89","d":"M4 4h16v16H4z"}}),_c('path',{attrs:{"d":"M17.776 7.502c.275.244.3.666.056.94l-7.112 8a.666.666 0 01-.996 0l-3.556-4a.667.667 0 11.997-.885l3.057 3.44 6.613-7.44a.667.667 0 01.941-.055z","fill":"#F7FAFC"}})])
          )
        }
      }
    